import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";

const Container = styled.div`
  margin-top: 0.2rem;
  float: left;
`;

export const HeaderWithBack = ({ handleBackButtonClicked, children }) => {
  return (
    <div>
      <Container>
        {handleBackButtonClicked && (
          <span>
            <FontAwesomeIcon
              icon={faArrowLeft}
              onClick={handleBackButtonClicked}
            />
          </span>
        )}
      </Container>
      {children}
    </div>
  );
};
